<template>
	<div class="page-dashboard relative">
		<div class="container-fluid">
			<h2 class="text-primary mb-4">{{ $t(title) }}</h2>
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<div>
					<button
						class="btn btn-submit btn-default"
						@click="addItem">
						{{ $t('Create Output') }}
					</button>
					<button
						v-if="filteredDisplayRundown.length > 1"
						class="btn btn-submit btn-primary ml-3"
						@click="goToMutilview" v-click-outside="hideContextRundown" @contextmenu.prevent @contextmenu="toggleContextRundown()">
						{{ $t('Multiview') }}
					</button>
				</div>
				<!-- counting -->
				<div class="mr-3 ml-a">
					<md-menu md-align-trigger md :md-offset-x=10>
						<button class="btn-icon btn p-0 m-0 w-100 btn-click" md-menu-trigger>
								{{ page * limit - (limit - 1) }} - {{ items.length > 0 ? page * limit : items.length }} of {{ totalItems }}
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="changeLimit(10)"><span class="text-center minw-50">10</span></md-menu-item>
							<md-menu-item @click="changeLimit(25)"><span class="text-center minw-50">25</span></md-menu-item>
							<md-menu-item @click="changeLimit(50)"><span class="text-center minw-50">50</span></md-menu-item>
							<md-menu-item @click="changeLimit(100)"><span class="text-center minw-50">100</span></md-menu-item>
							<md-menu-item @click="changeLimit(200)"><span class="text-center minw-50">200</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<div>
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<!-- Main Table -->
			<table class="table table-striped mb-4">
				<thead>
					<tr>
						<th class="text-center" width="1%">{{ $t('Status') }}</th>
						<th>{{ $t('Output Name') }}</th>
						<th width="20%">{{ $t('Output Layers') }}</th>
						<th>{{ $t('Size') }}</th>
						<th>{{ $t('UID') }}</th>
						<th width="10%">{{ $t('Delay (ms)') }}</th>
						<th>{{ $t('Rundown') }}</th>
						<!-- <th class="text-center">{{ $t('Total Access') }}</th> -->
						<th width="20%">{{ $t('') }}</th>
					</tr>
				</thead>
				<div class="p-5 text-center absolute" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<tbody>
					<tr
						v-for="item in items"
						:key="item.id" @dblclick="editItem(item)">
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" class="text-center">
							<div class="d-flex">
								<div
									class="status-dot m-auto"
									:class="{ 'active': item.is_active }"
									v-tooltip="item.is_active ? 'Active' : 'Inactive'">
								</div>
								<!-- if display shared by -->
								<div v-if="user && item.user_id !== user.id" v-tooltip.bottom-end="{ content: `Shared by ${item.user.name}` }" class="d-flex pt-1">
									<svg class="pb-1 ml-1" style="width:24px;height:24px" viewBox="0 0 24 24">
										<path fill="#FFA800" d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />
										<path v-if="hover && hoverItem === item.id" fill="balck" d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />
									</svg>
								</div>
								<!-- if display shared with -->
								<div v-if="user && item.user_id === user.id && item && item.collaborators && item.collaborators.length > 0" v-tooltip.bottom-end="{ content: collaboratorList(item), classes: 'tooltip-render-displays' }">
									<svg class="pb-1 ml-1" style="width:24px;height:24px" viewBox="0 0 24 24">
										<path fill="#FFA800" d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />
										<path v-if="hover && hoverItem === item.id" fill="balck" d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />
									</svg>
								</div>
							</div>
						</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.name }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<span v-for="(itemIndex, index) in JSON.parse(item.layer_index)" :key="index" v-show="index <= 9">
								<md-chip class="mr-2 chip-item" :class="{'chip-item-hover': hover && hoverItem === item.id}" v-if="itemIndex === '0'">
									All
								</md-chip>
								<md-chip class="mr-2 chip-item" :class="{'chip-item-hover': hover && hoverItem === item.id}" v-if="itemIndex !== '0'">
									{{ itemIndex }}
								</md-chip>
								<md-chip v-tooltip="'More details'" @click="editItem(item)" class="mr-2 chip-item pointer" :class="{'chip-item-hover': hover && hoverItem === item.id}" v-if="index === 9">
									...
								</md-chip>
							</span>
						</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.displaySize ? `${item.displaySize.name} (${item.displaySize.width} - ${item.displaySize.height})`: '-' }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.unique_code }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item && item.delay ? item.delay : '-'  }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" @click="goToRundown(item.rundown)">
							<md-chip v-if="item.rundown && item.rundown.name" class="mr-2 chip-item pointer" :class="{'chip-item-hover': hover && hoverItem === item.id}">
								{{ item.rundown.name }}
							</md-chip>
							<div class="ml-3" v-else>
								-
							</div>
						</td>
						<td class="text-right">
							<md-menu md-size="medium" md-align-trigger>
								<div class="btn btn-icon" md-menu-trigger><i class="material-icons text-white">more_vert</i></div>
								<md-menu-content>
								<md-menu-item v-if="!item.lightstream" @click="addingLighstream(item)" :class="{'disabled-w-bg': isAddLightstream}"><span :class="{'text-grey': isAddLightstream}">{{$t('Add Project Lighstream')}}</span></md-menu-item>
								<md-menu-item v-if="item.lightstream" @click="openStream(item)">{{$t('Stream Destination')}}</md-menu-item>
								<md-menu-item v-if="item.lightstream" @click="openLayout(item)">{{$t('Stream Output Resolution')}}</md-menu-item>
								<md-menu-item @click="duplicateItem(item)">{{$t('Duplicate')}}</md-menu-item>
								<md-menu-item @click="view(item)">{{$t('View in browser')}}</md-menu-item>
								<md-menu-item @click="editItem(item)">{{$t('Edit')}}</md-menu-item>
								<md-menu-item v-if="item.user_id === user.id" @click="confirmClearItem(item)">{{$t('Clear Output Access')}}</md-menu-item>
								<md-menu-item v-if="item.user_id === user.id" @click="confirmRemoveItem(item)">{{$t('Delete')}}</md-menu-item>
								</md-menu-content>
							</md-menu>
						</td>
					</tr>
				</tbody>
				<div class="text-center absolute disabled mt-4" v-if="items.length === 0 && !isFetching">{{$t('No Display available')}}</div>
			</table>
			<!-- Table Pagination -->
			<pagination
				v-if="!isFetching"
				:total-pages="totalPages"
				:current-page="page"
				:last-page="lastPage"
				@select="onPageSelected">
			</pagination>
		</div>
		<!-- Modals -->
		<div class="modals">
			<!-- Form -->
			<display-form
				:sizes="sizes"
				:data="selected"
				@saved="insertItem"
				@close="isFormVisible = false"
				v-if="isFormVisible"
			/>

			<!-- Delete Confirmation -->
			<modal
				size="small"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selected">
				<template slot="header">
					{{ $t('Confirm Delete') }}
				</template>
				<template slot="body">
					{{ $t('Delete Output') }} {{ selected.name }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selected)">
							{{ $t('Yes, Delete It') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- Clear Confirmation -->
			<modal
				size="small"
				@close="isConfirmClearVisible = false"
				v-if="isConfirmClearVisible && selected">
				<template slot="header">
					{{ $t('Confirm Clear Output Access') }}
				</template>
				<template slot="body">
					{{ $t('Clear Output') }} {{ selected.name }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isClear }"
							@click="clearItem(selected)">
							{{ $t('Yes, Clear It') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmClearVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- modal layout lightstream -->
			<layout-lightstream-form v-if="isUpdateLayoutModal" :data="selected" @close="isUpdateLayoutModal = false"></layout-lightstream-form>
			<!-- modal stream key lightstream -->
			<stream-key-lightstream-list v-if="isUpdateStreamKeyModal" :data="selected" @close="isUpdateStreamKeyModal = false"></stream-key-lightstream-list>
		</div>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import DisplayForm from '@/components/DisplayForm.vue';
import LayoutLightstreamForm from '@/components/LayoutLightstreamForm.vue';
import StreamKeyLightstreamList from '@/components/StreamKeyLightstreamList.vue';
import Pagination from '@/components/Pagination.vue';
import { getAxiosErrorMessage, delay, copyToClipboard } from '@/lib/helper';
import displaysApi from '@/api/displays';
import displaySizesApi from '@/api/display-sizes';
import lightstreamsApi from '@/api/lightstream';

export default {
	name: 'Displays',
	components: {
		Modal,
		DisplayForm,
		Pagination,
		LayoutLightstreamForm,
		StreamKeyLightstreamList,
	},
	data() {
		return {
			page: 1,
			limit: 10,
			orderBy: 'id',
			sortBy: 'desc',
			keyword: '',
			role: 'client',
			isAll: false,
			items: [],
			selected: null,
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			roles: [
				{ key: 'all', label: 'All Roles' },
				{ key: 'client', label: 'Client' },
				{ key: 'super_admin', label: 'Super Admin' },
				{ key: 'collaborator', label: 'Collaborator' },
			],
			filterRole: null,
			isFormVisible: false,
			isConfirmRemoveVisible: false,
			isRemoving: false,
			isConfirmClearVisible: false,
			isClear: false,
			title: 'Outputs',
			isDuplicating: false,
			isFetching: false,
			hover: false,
			hoverItem: null,
			sizes: [],
			isContext: false,
			// add lightstream
			isAddLightstream: false,
			isUpdateLayoutModal: false,
			isUpdateStreamKey: false,
			isUpdateLayout: false,
			isUpdateStreamKeyModal: false,
		};
	},
	directives: {
		ClickOutside,
	},
	methods: {
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.id;
		},
		...mapActions({
		}),
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) {
				this.page = page;
			}
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) {
					this.isAll = true;
				}
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Outputs',
					text: message,
				});
				this.isFetching = false;
			};
			displaysApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 500);
		},
		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			} else {
				this.$set(this.items, index, item);
			}
		},
		addItem() {
			this.selected = null;
			this.isFormVisible = true;
		},
		editItem(item) {
			this.selected = item;
			this.isFormVisible = true;
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		confirmClearItem(item) {
			this.selected = item;
			this.isConfirmClearVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.items.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Delete Output',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Delete Output',
					text: message,
				});
			};
			displaysApi.delete(item.id, callback, errorCallback);
		},
		clearItem(item) {
			this.isClear = true;
			const callback = (response) => {
				const message = response.message;
				this.isClear = false;
				this.isConfirmClearVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Clear Output',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isClear = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Clear Output',
					text: message,
				});
			};
			displaysApi.clearAccess(item.id, callback, errorCallback);
		},
		duplicateItem(item) {
			this.isDuplicating = true;
			const name = `Duplicate of ${item.name}`;
			const description = item.description;
			const params = {
				name,
				description,
				display_size_id: item.display_size_id,
				is_active: item.is_active,
				is_default: item.is_default,
				is_transparent: item.is_transparent,
				is_preload: item.is_preload,
				layer_index: item.layer_index,
				background_color: item.background_color,
			};
			const callback = (response) => {
				const duplicatedItem = response.data;
				this.items.push(duplicatedItem);
				const message = response.message;
				this.isDuplicating = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Duplicate Output',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isDuplicating = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Duplicate Output',
					text: message,
				});
			};
			displaysApi.create(params, callback, errorCallback);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
		view(item) {
			const rundownId = item && item.rundown && item.rundown.id ? item.rundown.id : '';
			const url = `displays/live/${btoa(item.slug)}/${btoa(item.id)}?${btoa('rundown_id=')}${rundownId}`;
			// this.$router.push(url);
			const route = this.$router.resolve({ path: url });
			// let route = this.$router.resolve('/link/to/page'); // This also works.
			window.open(route.href, '_blank');
			// window.open(url);
			// toggleFullScreen();
		},
		changeLimit(value) {
			this.limit = value;
			this.fetch(true);
		},
		fetchSizes() {
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'name',
				sort_by: 'asc',
			};
			const callback = (response) => {
				const sizes = response.data;
				const sizesWith = sizes.filter(item => item.name.includes('3840x2160') || item.name.includes('1280x720') || item.name.includes('1920x1080'));
				this.sizes = sizes.filter(item => !item.name.includes('3840x2160') && !item.name.includes('1280x720') && !item.name.includes('1920x1080'));
				this.sizes.splice(0, 0, ...sizesWith);
			};
			const errorCallback = () => {};
			displaySizesApi.getList(params, callback, errorCallback);
		},
		goToMutilview() {
			const routeData = this.$router.resolve(`/multiview-displays/${btoa(`?ownmultipviewuserid=${this.user.id}`)}`);
			window.open(routeData.href, '_blank');
		},
		toggleContextRundown() {
			this.isContext = !this.isContext;
			const baseUrl = process.env.VUE_APP_URL;
			const url = `${baseUrl}/multiview-displays/${btoa(`?ownmultipviewuserid=${this.user.id}`)}`;
			copyToClipboard(url);
			const message = this.$t('URL copied to clipboard');
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Multiple Output Display',
				text: message,
			});
		},
		hideContextRundown() {
			this.isContext = false;
		},
		goToRundown(rundown) {
			if (rundown && rundown.slug) {
				this.$router.push(`/rundowns/editor/${btoa(rundown.slug)}`);
			}
		},
		addingLighstream(display) {
			this.isAddLightstream = true;
			const rundownId = display && display.rundown && display.rundown.id ? display.rundown.id : '';
			const baseUrl = process.env.VUE_APP_URL;
			const url = `${baseUrl}/displays/live/${btoa(display.slug)}/${btoa(display.id)}?${btoa('rundown_id=')}${rundownId}`;
			const params = {
				display_id: display.id,
				display_url: url,
			};
			const callback = (response) => {
				const message = response.message;
				const item = response.data;
				this.insertItem(item);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add project',
					text: message,
				});
				this.isAddLightstream = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add project',
					text: message,
				});
				this.isAddLightstream = false;
			};
			lightstreamsApi.create(params, callback, errorCallback);
		},
		openLayout(item) {
			this.isUpdateLayoutModal = true;
			this.selected = item;
		},
		openStream(item) {
			this.isUpdateStreamKeyModal = true;
			this.selected = item;
		},
		updateStreamKey() {

		},
		updateLayout() {

		},
		collaboratorList(item) {
			const collabResult = [];
			const collab = item && item.collaborators ? item.collaborators : '';
			for (let index = 0; index < collab.length; index++) {
				const element = collab[index].name;
				collabResult.push(` ${element}`);
			}
			return `Shared with ${collabResult}`;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isCollaborator: 'isCollaborator',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
		filteredDisplayRundown() {
			const filtered = this.items.filter(item => item.rundown_id);
			return filtered;
		},
	},
	created() {
		this.fetch();
		this.fetchSizes();
	},
};
</script>
